module.exports = __webpack_public_path__ + "img/trip_14.011d527e.jpg";